import { z } from "zod";
import { IdSchema } from "./primitives";

export const ActionTextSchema = z.string().trim().min(1).max(20_000);

export const ActionOperationSchema = z.discriminatedUnion("type", [
  z.strictObject({
    type: z.literal("action.submitted"),
    action: z.strictObject({ id: IdSchema, text: ActionTextSchema }),
  }),
  z.strictObject({ type: z.literal("action.edited"), id: IdSchema, text: ActionTextSchema }),
  z.strictObject({ type: z.literal("action.withdrawn"), id: IdSchema }),
]);
export type ActionOperation = z.infer<typeof ActionOperationSchema>;
